import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_app/sales/offers/templates/$offerTemplateId/editor/")({
  beforeLoad: ({params}) => {
    throw redirect({
      to: "/sales/offers/templates/editor/$offerTemplateId",
      params: {offerTemplateId: params.offerTemplateId},
      replace: true,
    });
  },
});
